(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('InvoicesConfirmationController', InvoicesConfirmationController);

    InvoicesConfirmationController.$inject = ['$scope', '$rootScope', '$window', '$filter', '$state', '$stateParams', '$location', 'InvoicesService'];

    function InvoicesConfirmationController($scope, $rootScope, $window, $filter, $state, $stateParams, $location, InvoicesService) {

        var vm = this;    

        vm.invoice_type = $state.current.data.invoice_type;

        vm.base_url         = base_url;

        vm.goToForm         = goToForm;
        vm.submit           = submit;
        vm.getInvoiceId     = getInvoiceId;
        vm.getInvoiceURL    = getInvoiceURL;
        vm.unloadPage       = unloadPage;
        vm.isEdit           = $state.current.data.isEdit;

        console.log($state.current.data);

        vm.data = InvoicesService.getData();                

        vm.showAdditionalServices = false;

        vm.formErrors = [];        

        activate();

        function unloadPage()
        {
            InvoicesService.setData(vm.data);

            if (vm.invoice_type == 'expo') {
                $state.go("root.invoices.confirmation");
            } else {
                $state.go("root.invoices." + vm.invoice_type + ".confirmation");
            }
        }        

        function activate() {

            if (vm.data == undefined) {
                $state.go("root.invoices." + vm.invoice_type);            
            }

            var additionalServices = $filter('filter')(vm.data.user['additional_services']['items'], {removed: false});

            if (additionalServices.length > 0)
                vm.showAdditionalServices = true;
        }

        function goToForm() {
            InvoicesService.setData(vm.data);
            var params = {};

            if (vm.data.user['exhibitor'].user_id) {
                params.id = vm.data.user['exhibitor'].user_id;
            }

            if (vm.data.invoiceCurrency.code) {
                params.currency = vm.data.invoiceCurrency.code;
            }

            if (vm.data.query['expo_id']) {
                params.expo_id = vm.data.query['expo_id'];
            }

            if (vm.data.query['virtual_fair_id']) {
                params.virtual_fair_id = vm.data.query['virtual_fair_id'];
            }

            if (vm.invoice_type == 'expo') {
                $state.go("root.invoices.create", params);
            } else {
                $state.go("root.invoices." + vm.invoice_type + ".create", params);
            }
        }   

        function submit() {            
            vm.fields = {
                invoice_type                : vm.invoice_type,
                customer_id                 : vm.data.user['exhibitor'].user_id,
                seller_id                   : vm.data.sellerSelected.id,
                fpp_company                 : vm.data.companySelected.id,
                control_id                  : vm.data.control_id,
                customer_type               : vm.data.user['exhibitor'].customer_type,
                customer_vat                : vm.data.customerVAT,
                customer_po_number          : vm.data.customerPONumber,
                customer_tax_id             : vm.data.customerTaxId,
                customer_country_id         : vm.data.customerCountry.id,
                total_rate                  : vm.data.subtotal,
                discount_rate               : vm.data.discount,
                discount_webinars_rate      : vm.data.discountWebinar,
                discount_plan_rate          : vm.data.discountPlan,
                discount_email_blasts_rate  : vm.data.discountEmailBlast,
                credit_rate                 : vm.data.creditRate,
                total_vat                   : vm.data.totalVat,
                non_commissionable          : vm.data.nonCommissionable,
                observation                 : vm.data.notes,
                customer_legal_name         : vm.data.customerLegalName,
                contact_name                : vm.data.user['exhibitor'].contact_name,
                contact_email               : vm.data.user['exhibitor'].email,
                customer_address            : vm.data.user.address,
                sent_to                     : vm.data.sentTo,
                status                      : 'waiting_accept',
                created_at                  : $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                due_date                    : $filter('date')(vm.data.dueDate, 'yyyy-MM-dd HH:mm:ss'),
                invoice_date                : $filter('date')(vm.data.invoiceDate, 'yyyy-MM-dd HH:mm:ss'),
                currency                    : vm.data.invoiceCurrency.code,
                exchange_rate               : vm.data.exchangeRate,
                free_events                 : vm.data.free_events,            
            };

            if (vm.data.currency) {
                vm.fields.expo_currency = vm.data.currency;
            }

            if (vm.data.invoiceSource) {
                vm.fields.invoice_source = vm.data.invoiceSource;
            }

            var items = [];  

            if (vm.data.user['expos']) {
                angular.forEach(vm.data.user['expos'], function (expo) {
                    angular.forEach(expo['items'], function (item) {
                        if (item.removed != true) {

                            if (item.redeemed_item) {
                                item.loyalty_program_item_user_id = item.redeemed_item.id;
                            }

                            delete item.id;
                            delete item.classIcon;
                            delete item.classColor;
                            delete item.removed;
                            delete item.originalRate;
                            delete item.seller;   
                            delete item.redeemed_item;                

                            items.push(item);
                        }
                    });
                });
            }

            if (vm.data.user['virtual_fairs']) {
                angular.forEach(vm.data.user['virtual_fairs']['items'], function (item) {
                    if (item.removed != true) {

                        if (item.redeemed_item) {
                            item.loyalty_program_item_user_id = item.redeemed_item.id;
                        }

                        delete item.id;
                        delete item.classIcon;
                        delete item.classColor;
                        delete item.removed;
                        delete item.originalRate;
                        delete item.seller;
                        delete item.redeemed_item;  

                        items.push(item);
                    }
                }); 
            }

            if (vm.data.user['general']) {
                angular.forEach(vm.data.user['general']['items'], function (item) {
                    if (item.removed != true) {

                        if (item.redeemed_item) {
                            item.loyalty_program_item_user_id = item.redeemed_item.id;
                        }

                        delete item.id;
                        delete item.classIcon;
                        delete item.classColor;
                        delete item.removed;
                        delete item.originalRate;
                        delete item.seller;
                        delete item.redeemed_item;  

                        items.push(item);
                    }
                }); 
            }

            angular.forEach(vm.data.user['additional_services']['items'], function (item) {
                if (item.removed != true) {
                    item.seller_id = item.seller.id;   

                    if (item.redeemed_item) {
                        item.loyalty_program_item_user_id = item.redeemed_item.id;
                    }

                    delete item.id;
                    delete item.classIcon;
                    delete item.classColor;
                    delete item.removed;
                    delete item.originalRate;
                    delete item.seller; 
                    delete item.redeemed_item;     

                    items.push(item);
                }
            });   

            vm.fields.items = items;        

            InvoicesService.store(vm.fields)
                .then(function(response) {
                    if (response.errors) {
                        if (response.errors.control_id) {
                            var params = { 
                                id: vm.data.user['exhibitor'].user_id, 
                                errors: response.errors.control_id[0]
                            };
                        } else {
                            var errors = '';
                            for ( var key in response.errors ) {
                                errors = errors + '* ' + response.errors[key][0] + '<br>'; 
                            }
                            alertify.notify('Sorry!<br><br>' + errors, 'error', 5);

                            return false;
                        }
                    } else {                        
                        var params = { 
                            id: vm.data.user['exhibitor'].user_id, 
                            invoice_created: response.id,
                        };                        
                    }

                    if (vm.data.query['expo_id']) {
                        params.expo_id = vm.data.query['expo_id'];
                    } 

                    if (vm.data.query['virtual_fair_id']) {
                        params.virtual_fair_id = vm.data.query['virtual_fair_id'];
                    } 

                    if (vm.invoice_type == 'expo') {
                        $state.go("root.invoices.user", params);
                    } 
                    if (vm.invoice_type == 'virtual_fair') {
                        $state.go("root.invoices.virtual_fair.user", params);
                    }
                    if (vm.invoice_type == 'general') {
                        $state.go("root.invoices.search", params);
                    }
                })
                .catch(function(err) {
                    alertify.notify('Sorry, an error occurred!', 'error', 5);
                    console.log(err);
                });
        }   

        function getInvoiceId() {
            var d = new Date();
            return $filter('date')(d, 'yyyyMMddHHmmss');
        }

        function getInvoiceURL(id) {
            for (var x=0; x<5; x++) {
                id = btoa(id); // apply base64 first 
                id = id.split("").reverse().join(""); // and then reverse the string
                id = id.replace('==', '');
            }

            if (vm.invoice_type == 'expo') {
                return 'http://d04hexi3c25018r.canoodo.com/expos/invoices/' + id + '/show';
            } else {
                return 'http://d04hexi3c25018r.canoodo.com/invoices/' + id + '/show';
            }
        }

    }

})();